import React from 'react';
import { getCountryCallingCode } from 'react-phone-number-input';
import SelectCountryStyled from './bundle.esm2.js';
import { defaultFunction } from '../../../utils/bundle.esm2.js';
import { findFlagIconByCountryCode } from '../../../utils/bundle.esm6.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SelectCountry = (props) => {
  const _a = props, {
    value,
    options,
    className,
    disabled,
    onChange = defaultFunction
  } = _a, rest = __objRest(_a, [
    "value",
    "options",
    "className",
    "disabled",
    "onChange"
  ]);
  return /* @__PURE__ */ React.createElement(SelectCountryStyled, {
    className: `SelectCountry ${className}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "SelectCountry__flag"
  }, findFlagIconByCountryCode(value)), /* @__PURE__ */ React.createElement("select", __spreadValues({
    className: "SelectCountry__select",
    disabled,
    onChange,
    value
  }, rest), options == null ? void 0 : options.map((value2, index) => {
    return /* @__PURE__ */ React.createElement("option", {
      key: index,
      value: value2,
      className: "SelectCountry__option"
    }, `+${getCountryCallingCode(value2 != null ? value2 : "EC")}`);
  })));
};
SelectCountry.defaultProps = {
  className: ""
};

export { SelectCountry as default };
//# sourceMappingURL=bundle.esm.js.map
